import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import history from "../login/history";
import ButtonLink from "../../generico/ButtonLink";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { RuedaDetalle } from "./RuedaDetalle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import RuedaService from "../../../services/rueda/RuedaService";
import { trackPromise } from "react-promise-tracker";


const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

const PAGAR_RUEDA = 61;
export default class RuedaSocio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      parametros: []
    }

  }

  componentDidMount() {

  }

  getColumnDetalle() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta,
        width: "100px"
      },
      {
        name: "Grupo",
        selector: row => row.grupo,
        width: "80px"
      },
      {
        name: "Plan",
        selector: row => row.plan,
        width: "80px"
      },
      {
        name: "Contrato",
        selector: row => row.contrato,
        width: "110px"
      },
      {
        name: "Cuota",
        selector: row => row.cuota,
        width: "80px"
      },
      {
        name: "Monto",
        selector: row => row.monto
      },
      {
        name: "Depósito",
        selector: row => row.depositos
      },
      {
        name: "Último Pago",
        selector: row => row.ultimoPago
      },
      {
        cell: (row) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <ButtonLink
              className="btn btn-cu-terciary mb-1"
              param={row}
              url={ConfigService.getPathById(PAGAR_RUEDA)?.url}
              onClick={this.pagarRueda}>
              <FontAwesomeIcon icon={faMoneyBill} /> Pagar
            </ButtonLink>
            <button
              className="btn btn-cu-terciary"
              style={ConfigService.ocultarSegunNombre("verContratoRueda")}
              onClick={() => this.verContrato(row)}>
              <FontAwesomeIcon style={{ color: "#fff" }} icon={faFilePdf} /> Ver Contrato
            </button>
          </div>
        ),
        width: "150px",
      }
    ];
  }

  

  pagarRueda = (url, row) => {
    sessionStorage.setItem("PAGO_RUEDA", JSON.stringify(row));
    history.push(url)
    window.location.reload();
  }


  obtenerParametros = async (grupo) => {

    return new Promise((resolve, reject) => {

      trackPromise(

        RuedaService.obtenerParametros(grupo)
          .then(({ data }) => {

            let { codigo, mensaje, detalles } = data;

            if (codigo === "0") {
              resolve(detalles);
            } else {
              resolve([]);
            }

          })
          .catch(error => {
            console.log(error);
            reject();
          })
      )

    });

  }

  verContrato = async (row) => {

    let array = [];
    array.length = 60;

    let data = {
      titulo: "CONTRATO DE LA RUEDA GIGANTE DE SOLIDARIDAD",
      idGrupo: row.grupo,
      nroOrden: row.contrato,
      nroCuentaAsignada: row.cuenta,
      nombreSocio: authService.getSocio().nombreCompleto,
      nroSocio: authService.getSocio().numeroSocio,
      cedulaIdentidad: authService.getSocio().numeroCedula,
      fecha: row.fechaInscripcion,
    }

    const parametros = await this.obtenerParametros(row.grupo);

    for (let index = 0; index < parametros.length; index++) {
      //console.log(valoresPfd[index].parametro);
      data[parametros[index].parametro] = parametros[index].valor;
    }

    trackPromise(
      RuedaService.reimprimirContrato(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  render() {
    return (
      <DataTable
        noHeader={true}
        pagination={true}
        columns={this.getColumnDetalle()}
        data={this.props.ruedaSocio}
        paginationComponentOptions={paginationOptions}
        noDataComponent="no hay registros para mostrar"
        responsive={true}
        striped={true}
        pointerOnHover
        expandableRows
        expandableRowsComponent={RuedaDetalle}
        progressPending={false}
      />

    );
  }
}